import PropTypes from "prop-types";
import {Row} from "react-bootstrap";

export function SelectionBar(props) {
    const {children, className} = props;
    return <Row className={'g-0 '+className}>
        {children}
    </Row>
}

SelectionBar.propTypes = {
    children: PropTypes.any,
    customStyle: PropTypes.object,
    className: PropTypes.string
};